export default function joinClassNames(...arg: (string | boolean | number | null | undefined)[]) {
  if (arg.length === 1) return arg[0] ? '' + arg[0] : '';
  return arg.filter(i => i).join(' ');
}